import React from 'react';

interface Icon {
  color?: string;
  width?: number;
  height?: number;
}

const timeSquare: React.FC<Icon> = ({ color, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.67 0H14.34C17.73 0 20 2.379 20 5.919V14.089C20 17.62 17.73 20 14.34 20H5.67C2.28 20 0 17.62 0 14.089V5.919C0 2.379 2.28 0 5.67 0ZM13.58 13.81C13.83 13.81 14.08 13.68 14.22 13.44C14.44 13.089 14.32 12.629 13.96 12.41L10.4 10.29V5.669C10.4 5.26 10.07 4.919 9.65 4.919C9.24 4.919 8.9 5.26 8.9 5.669V10.72C8.9 10.98 9.04 11.23 9.27 11.36L13.19 13.7C13.31 13.78 13.45 13.81 13.58 13.81Z"
        fill={color}
      />
    </svg>
  );
};

export default timeSquare;
